import axiosPrivateMl from "./axiosPrivateMl"

export const fetchUserStats = async (userId) => {
  return axiosPrivateMl.post(`user_stats`, {
    user_id: userId,
  })
}
